export default __webpack_public_path__ + "static/media/MyNavBar.43f56217.bin";